import React from 'react';
import styles from '../styles/HeaderSkeleton.module.css';

export const HeaderSkeleton = () => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <div className={`${styles.logo} ${styles.pulse}`} />
        <div className={styles.metaWrapper}>
          <div className={`${styles.line} ${styles.pulse}`} />
          <div className={`${styles.line} ${styles.pulse}`} />
        </div>
        <div className={styles.cart}>
          <div className={`${styles.cartText} ${styles.pulse}`} />
          <div className={`${styles.cartIcon} ${styles.pulse}`} />
        </div>
      </div>
    </header>
  );
};
